import { useQuery } from "@tanstack/react-query";
import { ORGANIZATION_KEYS } from "./queryKeys";
import { getRebuildAPI } from "@rebuild/shared/api";

const { tpaControllerList } = getRebuildAPI();

export function useGetTPAsQuery() {
  return useQuery({
    queryKey: ORGANIZATION_KEYS.tpas(),
    queryFn: async () => {
      const { data } = await tpaControllerList();
      return data ?? [];
    },
  });
}
